/* ==========================================================================
   CalendarRxjs > Client > Helpers
   ========================================================================== */

/* Constat */
const DEVICE_MOBILE = 'mobile';
const MODE_RANGE = 'range';
const MODE_SINGLE = 'single';
const MODE_TIME = 'time';

/* Device */
const isMobile = (device = String) => String(device).toLowerCase() === DEVICE_MOBILE;

/* Mode */
const isModeRange = (mode = String) => mode.toLowerCase() === MODE_RANGE;
const isModeSingle = (mode = String) => mode.toLowerCase() === MODE_SINGLE;
const isModeTime = (mode = String) => mode.toLowerCase() === MODE_TIME;

/* Exports */
module.exports = {
    modes: {
        MODE_RANGE,
        MODE_SINGLE,
        MODE_TIME
    },
    isMobile,
    isModeRange,
    isModeSingle,
    isModeTime
};
